// src/plugins/imageUrl.js

import Vue from "vue";
import constant from "../constant";

const imageUrlPlugin = {
  install(Vue) {
    // Helper function to check if URL is local (localhost or local IP)
    const isLocalUrl = (url) => {
      if (!url) return false;
      return (
        url.includes("localhost") ||
        url.includes("127.0.0.1") ||
        /192\.168\.\d+\.\d+/.test(url) ||
        /10\.\d+\.\d+\.\d+/.test(url) ||
        /172\.(1[6-9]|2[0-9]|3[0-1])\.\d+\.\d+/.test(url)
      );
    };

    // Helper function to remove /public from path
    const removePublicFromPath = (path) => {
      if (!path) return path;
      // Remove /public/ or /public from the path
      return path.replace(/\/public\//g, "/").replace(/\/public$/g, "");
    };

    const imageUrl = (path) => {
      try {
        // 🧩 Si vide ou invalide → image par défaut
        if (!path || path === null || path === "" || path === "null") {
          // Use a placeholder or default image path
          return require("../assets/logo.png");
        }

        // 🧩 Si constant.url est local (localhost ou IP locale) et path contient /public → retirer /public
        if (isLocalUrl(constant.url) && path.includes("/public")) {
          path = removePublicFromPath(path);
        }

        // 🧩 Si déjà une URL complète
        if (path.startsWith("http")) {
          // ✅ Si l'URL contient "localhost" → la remplacer par constant.url
          if (path.includes("localhost") || path.includes("127.0.0.1")) {
            path = path.replace(
              /https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?/g,
              constant.url
            );
            // Retirer /public si constant.url est local
            if (isLocalUrl(constant.url)) {
              path = removePublicFromPath(path);
            }
          }

          // ✅ Si base est api.lebest.ma → injecter /public/ juste après le domaine
          if (constant.url === "https://api.lebest.ma") {
            return path.replace(
              "https://api.lebest.ma/",
              "https://api.lebest.ma/public/"
            );
          }

          // ✅ Sinon on garde telle quelle
          return path;
        }

        // 🧩 Si base est api.lebest.ma → forcer /public/
        if (constant.url === "https://api.lebest.ma") {
          const cleanPath = path.startsWith("/") ? path.substring(1) : path;
          return `https://api.lebest.ma/public/${cleanPath}`;
        }

        // 🧩 Si le chemin commence par "/" → concaténer avec constant.url
        if (path.startsWith("/")) {
          return `${constant.url}${path}`;
        }

        // 🧩 Sinon, chemin relatif → ajouter /
        return `${constant.url}/${path}`;
      } catch (e) {
        // 🧩 Fallback de sécurité
        console.error("Error processing image URL:", e);
        try {
          return require("../assets/logo.png");
        } catch (err) {
          // If require fails, return a data URI placeholder
          return "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100'%3E%3Crect fill='%23ddd' width='100' height='100'/%3E%3Ctext fill='%23999' font-family='sans-serif' font-size='14' x='50%25' y='50%25' text-anchor='middle' dy='.3em'%3ENo Image%3C/text%3E%3C/svg%3E";
        }
      }
    };

    // Injection globale
    Vue.prototype.$imageUrl = imageUrl;
  },
};

export default imageUrlPlugin;
